module.exports = __webpack_public_path__ + "static/media/FemaleFounderActiveUpdated.8f5a2aa3.svg";